import React from "react";
export const DataIcon = (props: any) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="7.99984" cy="3.33337" rx="5.33333" ry="2" stroke={props.color || "#292D32" } stroke-width="1.15" />
        <path d="M13.3332 8C13.3332 9.10457 10.9454 10 7.99984 10C5.05432 10 2.6665 9.10457 2.6665 8" stroke={props.color || "#292D32" } stroke-width="1.15" />
        <path d="M13.3332 3.33337V12.6667C13.3332 13.7713 10.9454 14.6667 7.99984 14.6667C5.05432 14.6667 2.6665 13.7713 2.6665 12.6667V3.33337" stroke={props.color || "#292D32" } stroke-width="1.15" />
        <path d="M5.3335 5.33337V6.66671" stroke={props.color || "#292D32" } stroke-width="1.15" stroke-linecap="round" />
        <path d="M5.3335 10V11.3333" stroke={props.color || "#292D32" } stroke-width="1.15" stroke-linecap="round" />
    </svg>

) 